import { observer } from "mobx-react-lite";
import * as React from "react";
import { ZAttrColSpan, ZAttrNewLine } from "src/business/attribute/ZAttrEdit";

import { MfNode, RenderCtx } from "../../node/MfNode";
import { ZMfNodeGrid } from "../../ZMfNode";
import * as styles from "./MfGridView.module.less";

type PropsMfGridView = {
  items: MfNode[];
  meta: ZMfNodeGrid;
  ctx: RenderCtx;
};

export const MfGridView: React.FC<PropsMfGridView> = observer((props) => {
  const { items, meta, ctx } = props;
  const colsCount = meta.columnsCount ?? 3;
  return (
    <div className={styles.gridBox}>
      {meta.title && <div className={styles.title}>{meta.title}</div>}
      <div
        className={styles.gridContent}
        style={{ gridTemplateColumns: `repeat(${colsCount}, minmax(0,1fr))` }}
      >
        {items
          .filter((node) => !node.hidden)
          .map(({ key, Render, colSpan, newLine }) => (
            <div
              key={key}
              className={styles.cell}
              style={gridItemStyle(colSpan, colsCount, newLine)}
            >
              <Render ctx={ctx} />
            </div>
          ))}
      </div>
    </div>
  );
});

const gridItemStyle = (
  colSpan: ZAttrColSpan,
  colsCount: number,
  newLine: ZAttrNewLine,
): React.CSSProperties => {
  const res: React.CSSProperties = {};

  if (colSpan) {
    const span = colSpan === "*" ? colsCount : colSpan;

    // newLine начинает размещение с первой линии сетки,
    // сохраняя количество колонок, заданное через colSpan.
    res.gridColumn = newLine ? `1 / span ${span}` : `span ${span}`;
  } else if (newLine) {
    res.gridColumn = "1";
  }

  // TODO: rowspan
  return res;
};
